import Vue from 'vue'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// import {
//     Pagination,
//     Dialog,
//     Dropdown,
//     DropdownMenu,
//     DropdownItem,
//     Menu,
//     Submenu,
//     MenuItem,
//     Input,
//     InputNumber,
//     Radio,
//     RadioGroup,
//     Checkbox,
//     CheckboxGroup,
//     Select,
//     Option,
//     Button,
//     Table,
//     TableColumn,
//     DatePicker,
//     TimeSelect,
//     TimePicker,
//     Breadcrumb,
//     BreadcrumbItem,
//     Form,
//     FormItem,
//     Tabs,
//     TabPane,
//     Tag,
//     Tree,
//     Row,
//     Col,
//     Upload,
//     Card,
//     Popover,
//     Popconfirm,
//     Rate,
//     Steps,
//     Step,
//     Cascader,
//     Loading,
//     MessageBox,
//     Message,
//     Notification,
//     Tooltip,
//     Switch,
//     Collapse,
//     CollapseItem,
//     Alert,
//     Avatar,
//     Badge,
//     Carousel,
//     CarouselItem,
//     Image,
//     RadioButton,
//     OptionGroup,
//     Autocomplete,
//     InfiniteScroll,
//     Timeline,
//     TimelineItem
// } from 'element-ui'

// const loading: any = Loading
// const messageBox: any = MessageBox       // 不取别名会报错

// 设置语言
locale.use(lang)
// Vue.use(Pagination)
// Vue.use(Dialog)
// Vue.use(Dropdown)
// Vue.use(DropdownMenu)
// Vue.use(DropdownItem)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(Input)
// Vue.use(InputNumber)
// Vue.use(Radio)
// Vue.use(RadioGroup)
// Vue.use(Checkbox)
// Vue.use(CheckboxGroup)
// Vue.use(Select)
// Vue.use(Option)
// Vue.use(Button)
// Vue.use(Table)
// Vue.use(TableColumn)
// Vue.use(DatePicker)
// Vue.use(TimeSelect)
// Vue.use(TimePicker)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Tabs)
// Vue.use(TabPane)
// Vue.use(Tag)
// Vue.use(Tree)
// Vue.use(Row)
// Vue.use(Col)
// Vue.use(Upload)
// Vue.use(Card)
// Vue.use(Popover)
// Vue.use(Popconfirm)
// Vue.use(Rate)
// Vue.use(Steps)
// Vue.use(Step)
// Vue.use(Cascader)
// Vue.use(Tooltip)
// Vue.use(Switch)
// Vue.use(Collapse)
// Vue.use(CollapseItem)
// Vue.use(Alert)
// Vue.use(loading.directive)
// Vue.use(Avatar)
// Vue.use(Badge)
// Vue.use(Carousel)
// Vue.use(CarouselItem)
// Vue.use(Image)
// Vue.use(RadioButton)
// Vue.use(OptionGroup)
// Vue.use(Autocomplete)
// Vue.use(InfiniteScroll)
// Vue.use(Timeline)
// Vue.use(TimelineItem)

// Vue.prototype.$loading = loading.service
// Vue.prototype.$msgbox = messageBox
// Vue.prototype.$alert = messageBox.alert
// Vue.prototype.$confirm = messageBox.confirm
// Vue.prototype.$prompt = messageBox.prompt
// Vue.prototype.$notify = Notification
// Vue.prototype.$message = Message
